import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitSearchSubmit = (searchTerm: string, category: string, label: string) => {
    hitGoogleTagManager({
        event: "search",
        search_term: searchTerm,
        event_category: category,
        event_label: label
    });
};
